import Container from '@/components/Container';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import Preloader from '@/components/atoms/Preloader';
import React from 'react';
import AccordianCategories from './Components/AccordianCategories';
import { useWoocommerceContext } from '@/services/context/Woocommerce/WoocomerceProvider';

// Exact copy of ProductsList, differing only in the global it reads data
// from: fmtCustomShapesData (Foamite Shapes List builder pages) instead of
// fmtshapesdata (the foam/mattress/cushions shapes-list pipeline). The
// resolver (FoamiteShapesListResolver) produces the same
// { shapes: [{ node: {...} }] } shape, so every component below this
// point — AccordianCategories, ProductCategoriesPanel,
// AccordianCategoryShapes, AccordianIllustrationCard — is reused unchanged.
declare const wc_add_to_cart_params: { ajax_url: string };
declare const fmtCustomShapesData: any;
const FoamiteProductsList = (): JSX.Element => {
    const theme = useTheme();
    const [title, setTitle] = useState('');
    const { loading, setLoading } = useWoocommerceContext();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (fmtCustomShapesData) {
            setCategories(fmtCustomShapesData['shapes']);
        }
    }, [fmtCustomShapesData]);

    return (
        <>
            <>
                <Container
                    paddingX={'0px !important'}
                    paddingY={'0px !important'}
                >
                    {loading ? (
                        <Preloader />
                    ) : (
                        <>
                            {categories && categories.length > 0 && (
                                <AccordianCategories categories={categories} />
                            )}
                        </>
                    )}
                </Container>
            </>
        </>
    );
};

export default FoamiteProductsList;
